import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, Table, Tag, Typography, Modal, Space, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import PortfolioTags from './PortfolioTags'
const { Text, Paragraph } = Typography;

const Cheatsheet = ({ portfolios }) => {
  const [selectedPortfolio, setSelectedPortfolio] = useState(null);

  const columns = [
    {
      title: 'Portfolio Name',
      dataIndex: 'name',
      key: 'name',
      width: 200,
      render: (text, record) =>
          <Link to={`/public/portfolio/${record.id}`} className={'text-blue-500 font-medium text-default'}>
            {text}
          </Link>
    },
    {
      title: 'Tags',
      dataIndex: 'tags',
      key: 'tags',
      width: 150,
      render: (tags) => (
          <PortfolioTags tags={tags} />
      )
    },
      {
      title: 'Equity/Bond',
      dataIndex: 'targets',
      key: 'targets',
      width: 150,
      render: (targets) => (
          <span>{targets.equity} / {targets.fixed}</span>
      )
    },
    {
      title: 'Summary',
      dataIndex: ['attr', 'summary'],
      key: 'summary',
      width: '30%',
      render: (text) => (
        <div className="relative">
          <Paragraph
            ellipsis={{ rows: 4 }}
            style={{ marginBottom: 0 }}
          >
            {text}
          </Paragraph>
          {text && (
            <Tooltip title="Click row to view full details">
              <InfoCircleOutlined
                style={{
                  position: 'absolute',
                  right: 0,
                  bottom: 0,
                  color: '#1890ff'
                }}
              />
            </Tooltip>
          )}
        </div>
      )
    },
    {
      title: 'Use Case',
      dataIndex: ['attr', 'use_case'],
      key: 'use_case',
      width: '30%',
      render: (text) => (
        <div className="relative">
          <Paragraph
            ellipsis={{ rows: 4 }}
            style={{ marginBottom: 0 }}
          >
            {text}
          </Paragraph>
          {text && text !== "No use case available." && (
            <Tooltip title="Click row to view full details">
              <InfoCircleOutlined
                style={{
                  position: 'absolute',
                  right: 0,
                  bottom: 0,
                  color: '#1890ff'
                }}
              />
            </Tooltip>
          )}
        </div>
      )
    }
  ];

  return (
      <Card bordered={false}>
        <Table
          dataSource={portfolios}
          columns={columns}
          pagination={false}
          rowKey="id"
          onRow={(record) => ({
            onClick: () => setSelectedPortfolio(record),
            style: { cursor: 'pointer' }
          })}
          size="middle"
          style={{
            backgroundColor: 'white',
            borderRadius: 8
          }}
        />
      </Card>
  );
};

export default Cheatsheet;